/**
 * @file   src\mobile\components\Common\UserPlan\MonthlyMemberPlan.js
 * @brief  This file is responsible for monthly plan selction view for consumer user in mobile view
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import Button from "react-bootstrap/Button";

const MonthlyMemberPlan = (props) => {
  const {
    userDetails,
    handleUpgrade,
    upgradeUserToFreePlan,
    handleDowngrade,
    ContactModalShow,
  } = props;
  return (
    <>
      <div className="mob-plan-wraper w-100 plan-bg-blue mb-20">
        <h4 className="d-flex align-items-center plan-color-blue">Member </h4>
        <p className="pb-20 plan-color-blue">
          Unlock features to get the most out of Gitcha for less.
        </p>
        <p className="short-para-blue">
          $13/month<span>Billed monthly</span>
        </p>
        <div className="btn-sec btn-sec-btmbrder-blue">
          {userDetails?.PlanName == null ? (
            <Button
              variant="primary"
              className="plan-btn btn btn-primary"
              onClick={() => handleUpgrade(2, "Member")}
            >
              Select
            </Button>
          ) : (
            <Button
              variant="primary"
              className="plan-btn btn btn-primary"
              disabled={
                userDetails?.PlanName === "Member" && userDetails?.period === 2
              }
              onClick={() => handleUpgrade(2, "Member")}
            >
              {userDetails?.PlanName === "Member" && userDetails?.period === 2
                ? "Your Current Plan"
                : userDetails?.PlanName === "Investor Member"
                ? "Downgrade"
                : "Upgrade"}
            </Button>
          )}
        </div>
        <ul className="plan-features-list plan-color-blue">
          <li className="plan-features-listbg-blue">Unlimited want-ads</li>
          <li className="plan-features-listbg-blue">
            Unlimited properties in your inventory
          </li>
          <li className="plan-features-listbg-blue">
            10 free introductions per month
          </li>
        </ul>
      </div>

      <div className="mob-plan-wraper w-100 plan-bg-blue mb-20">
        <h4 className="d-flex align-items-center plan-color-blue">Investor</h4>
        <p className="pb-20 plan-color-blue">
          Includes investor specific features to create more opportunities.
        </p>
        <p className="short-para-blue">
          $15/month<span>Billed annually</span>
        </p>
        <div className="btn-sec btn-sec-btmbrder-blue">
          {userDetails?.PlanName == null ? (
            <Button
              variant="primary"
              className="plan-btn btn btn-primary"
              onClick={() => handleUpgrade(2, "Investor Member")}
            >
              {" "}
              Select
            </Button>
          ) : (
            <Button
              variant="primary"
              className="plan-btn btn btn-primary"
              disabled={
                userDetails?.PlanName === "Investor Member" &&
                userDetails?.period === 2
              }
              onClick={() => handleUpgrade(2, "Investor Member")}
            >
              {userDetails?.PlanName === "Investor Member" &&
              userDetails?.period === 2
                ? "Current Plan"
                : "Upgrade"}
            </Button>
          )}
        </div>
        <ul className="plan-features-list plan-color-blue">
          <li className="plan-features-listbg-blue">
            Property management dashboard{" "}
          </li>
          <li className="plan-features-listbg-blue">
            Additional buyer box criteria
          </li>
          <li className="plan-features-listbg-blue">Unlimited want-ads</li>
          <li className="plan-features-listbg-blue">
            Unlimited properties in your inventory{" "}
          </li>
          <li className="plan-features-listbg-blue">
            10 free introductions per month
          </li>
          <li className="plan-features-listbg-blue">
            Custom Investor profile and badge
          </li>
        </ul>
      </div>

      <div className="mob-plan-wraper w-100 plan-bg-white plan-brdr-grey mb-20">
        <h4 className="d-flex align-items-center plan-color-black">Lite</h4>
        <p className="pb-20">
          Get a taste of what Gitcha can do with limited features.
        </p>
        <p className="short-para-black">Free</p>
        <div className="btn-sec btn-sec-btmbrder-grey">
          {userDetails?.PlanName == null ? (
            <Button
              variant="primary"
              onClick={() => upgradeUserToFreePlan()}
              className="plan-btn btn btn-primary"
            >
              Select
            </Button>
          ) : userDetails?.PlanName === "Lite" ? (
            <Button
              variant="primary"
              className="plan-btn btn btn-secondary-blue"
              disabled
            >
              Current plan
            </Button>
          ) : (
            <Button
              variant="outline"
              className="btn-outline-primary plan-btn downgrade-btn"
              onClick={() => handleDowngrade()}
            >
              Downgrade
            </Button>
          )}
        </div>
        <ul className="plan-features-list plan-features-listtext-black">
          <li className="plan-features-listbg-black">Pay per introduction</li>
          <li className="plan-features-listbg-black">
            Up to 2 properties in your inventory
          </li>
          <li className="plan-features-listbg-black">Unlimited want-ads</li>
        </ul>
      </div>
      <div className="mob-plan-wraper w-100 plan-bg-blue mb-20">
        <h4 className="d-flex align-items-center plan-color-blue">Enterprise</h4>
        <p className="pb-20 plan-color-blue">
          Want more seats for your company or team?
        </p>
        <p className="short-para-blue">Tiered pricing/seat</p>
        <div className="btn-sec btn-sec-btmbrder-blue">
          <Button
            variant="primary"
            className="plan-btn btn btn-primary"
            onClick={() => {
              ContactModalShow();
            }}
          >
            Contact us
          </Button>
        </div>
      </div>
    </>
  );
};

export default MonthlyMemberPlan;
